import Report from './ReportSetup';

export default Report;
